// Starlight: one-tap add-to-cart for pairing suggestions.
// Mirrors Dawn's product-form flow so the cart drawer re-renders in place.
// Without a cart drawer/notification (or if fetch fails) the form submits normally to /cart/add.
if (!customElements.get('sl-quick-add')) {
  customElements.define(
    'sl-quick-add',
    class SlQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.form.querySelector('[type="submit"]');
        this.error = this.querySelector('.sl-pairing__error');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(evt) {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!cart || typeof fetchConfig !== 'function') return;

        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.button.querySelector('.loading__spinner')?.classList.remove('hidden');
        if (this.error) this.error.hidden = true;

        const formData = new FormData(this.form);
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(this.button);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sl-quick-add',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            cart.classList.remove('is-empty');
            cart.renderContents(response);
          })
          .catch(() => this.form.submit())
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            this.button.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }
    }
  );
}
